var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFb = function SvgIconFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-fb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F9",
    d: "M8.275 18.125v-7.412H5.781v-2.89h2.494v-2.13c0-2.472 1.51-3.818 3.715-3.818 1.057 0 1.965.079 2.23.114v2.583l-1.53.001c-1.2 0-1.432.57-1.432 1.407v1.844h2.86l-.372 2.889h-2.488v7.412z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-fb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconFb;